import axios from "axios";
import { useState, useCallback } from "react";

export const useAxios = () => {
  const source = axios.CancelToken.source();
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const abort = useCallback(() => {
    source.cancel();
  }, []);

  const fetchData = async (options) => {
    setIsLoading(true);
    setError(null); // Reset error before new fetch
    try {
      const res = await axios({ ...options, cancelToken: source.token });
      setResponse(res.data);
      return { response: res.data, error: null, isLoading: false };
    } catch (err) {
      const data = err.response ? err.response.data : "Server error";
      setError(data);
      setResponse(null);
      return { response: null, error: data, isLoading: false };
    } finally {
      setIsLoading(false);
    }
  };

  const doFetch = useCallback((options = {}) => {
    return fetchData(options);
  }, []);

  return [{ response, error, isLoading }, doFetch, abort];
};

export default useAxios;
